import { Config } from "@config";
import { http } from "bm-ui-kit";
import type { FormFields, RiskInsuranceRequest, RiskInsuranceResponse } from "./types";

export function calculate(values: FormFields): Promise<RiskInsuranceResponse> {
	const request: RiskInsuranceRequest = {
		birthYear: values.birthYear,
		durationYears: values.durationYears,
		riskInsuranceAmount: values.riskInsuranceAmount,
		riskInsurance: values.mainInsuranceGoal === "RISK_INSURANCE",
		creditInsurance: values.mainInsuranceGoal === "CREDIT_INSURANCE",
		disability: values.additionalInsuranceGoal.includes("DISABILITY"),
		accidentProtection: values.additionalInsuranceGoal.includes("ACCIDENT_PROTECTION"),
		dreadDisease: values.additionalInsuranceGoal.includes("DREAD_DISEASE"),
	};

	return http.post(Config.getApiUrl("/api/public/risk/calculate"), request);
}
